import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './Envase.css';

function TDivisiones() {
  const [datos, setDatos] = useState([]);
  const [datosFiltrados, setDatosFiltrados] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [ordenAsc, setOrdenAsc] = useState(true);
  const [columnaOrden, setColumnaOrden] = useState('idDivision');

  // Modal
  const [modalAbierto, setModalAbierto] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [formulario, setFormulario] = useState({
    idDivision: '',
    nomDivision: ''
  });
  const [errores, setErrores] = useState({});

  const API_URL = '/api/divisiones';

  useEffect(() => {
    cargarDatos();
  }, []);

  useEffect(() => {
    filtrarDatos();
  }, [busqueda, datos]);

  const cargarDatos = async () => {
    try {
      const response = await axios.get(API_URL);
      setDatos(response.data);
      setDatosFiltrados(response.data);
    } catch (error) {
      console.error('Error al cargar datos:', error);
      alert('Error al cargar los datos');
    }
  };

  const filtrarDatos = () => {
    if (!busqueda) {
      setDatosFiltrados(datos);
      return;
    }

    const filtrados = datos.filter(item =>
      item.idDivision.toLowerCase().includes(busqueda.toLowerCase()) ||
      item.nomDivision.toLowerCase().includes(busqueda.toLowerCase())
    );
    setDatosFiltrados(filtrados);
  };

  const ordenarPor = (columna) => {
    const esAsc = columnaOrden === columna ? !ordenAsc : true;
    setColumnaOrden(columna);
    setOrdenAsc(esAsc);

    const ordenados = [...datosFiltrados].sort((a, b) => {
      const valorA = a[columna].toLowerCase();
      const valorB = b[columna].toLowerCase();

      if (esAsc) {
        return valorA > valorB ? 1 : -1;
      } else {
        return valorA < valorB ? 1 : -1;
      }
    });

    setDatosFiltrados(ordenados);
  };

  const exportarExcel = () => {
    const datosExportar = datosFiltrados.map(item => ({
      'ID División': item.idDivision,
      'Nombre División': item.nomDivision
    }));

    const ws = XLSX.utils.json_to_sheet(datosExportar);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Divisiones');
    XLSX.writeFile(wb, 'divisiones.xlsx');
  };

  const abrirModalNuevo = () => {
    setFormulario({ idDivision: '', nomDivision: '' });
    setModoEdicion(false);
    setModalAbierto(true);
  };

  const abrirModalEditar = (item) => {
    setFormulario({ idDivision: item.idDivision, nomDivision: item.nomDivision });
    setModoEdicion(true);
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setFormulario({ idDivision: '', nomDivision: '' });
    setErrores({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormulario({
      ...formulario,
      [name]: value
    });
    // Limpiar error del campo cuando el usuario empieza a escribir
    if (errores[name]) {
      setErrores({
        ...errores,
        [name]: ''
      });
    }
  };

  const validarFormulario = () => {
    const nuevosErrores = {};

    // Validar ID (requerido, 2 caracteres exactos, solo letras y números)
    if (!modoEdicion) {
      if (!formulario.idDivision.trim()) {
        nuevosErrores.idDivision = 'El ID es requerido';
      } else if (formulario.idDivision.trim().length !== 2) {
        nuevosErrores.idDivision = 'El ID debe tener exactamente 2 caracteres';
      } else if (!/^[a-zA-Z0-9]+$/.test(formulario.idDivision.trim())) {
        nuevosErrores.idDivision = 'El ID solo puede contener letras y números';
      } else {
        // Verificar duplicados
        const existe = datos.find(item =>
          item.idDivision.toLowerCase() === formulario.idDivision.trim().toLowerCase()
        );
        if (existe) {
          nuevosErrores.idDivision = 'Ya existe una división con este ID';
        }
      }
    }

    // Validar nombre (requerido y mínimo 3 caracteres)
    if (!formulario.nomDivision.trim()) {
      nuevosErrores.nomDivision = 'El nombre es requerido';
    } else if (formulario.nomDivision.trim().length < 3) {
      nuevosErrores.nomDivision = 'El nombre debe tener al menos 3 caracteres';
    } else if (formulario.nomDivision.trim().length > 140) {
      nuevosErrores.nomDivision = 'El nombre no puede tener más de 140 caracteres';
    } else {
      // Verificar si el nombre ya existe
      const nombreExiste = datos.find(item =>
        item.nomDivision.toLowerCase() === formulario.nomDivision.trim().toLowerCase() &&
        (!modoEdicion || item.idDivision !== formulario.idDivision)
      );
      if (nombreExiste) {
        nuevosErrores.nomDivision = 'Ya existe una división con este nombre';
      }
    }

    setErrores(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validar formulario antes de enviar
    if (!validarFormulario()) {
      return;
    }

    // Preparar datos para enviar
    const datosEnviar = {
      idDivision: formulario.idDivision.trim().toUpperCase(),
      nomDivision: formulario.nomDivision.trim()
    };

    try {
      if (modoEdicion) {
        await axios.put(`${API_URL}/${formulario.idDivision}`, datosEnviar);
        alert('División actualizada exitosamente');
      } else {
        await axios.post(API_URL, datosEnviar);
        alert('División creada exitosamente');
      }
      cargarDatos();
      cerrarModal();
    } catch (error) {
      console.error('Error al guardar:', error);
      if (error.response) {
        alert(`Error al guardar: ${error.response.data.message || 'Error del servidor'}`);
      } else if (error.request) {
        alert('Error de conexión con el servidor');
      } else {
        alert('Error al guardar la división');
      }
    }
  };

  const eliminar = async (id) => {
    if (window.confirm('¿Está seguro de eliminar esta división?')) {
      try {
        await axios.delete(`${API_URL}/${id}`);
        alert('División eliminada exitosamente');
        cargarDatos();
      } catch (error) {
        console.error('Error al eliminar:', error);
        alert('Error al eliminar la división');
      }
    }
  };

  return (
    <div className="envase-container">
      <div className="header-seccion">
        <h2>Divisiones</h2>
        <div className="acciones-header">
          <input
            type="text"
            placeholder="Buscar..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            className="input-busqueda"
          />
          <button onClick={abrirModalNuevo} className="btn btn-nuevo">
            ➕ Nuevo
          </button>
          <button onClick={exportarExcel} className="btn btn-exportar">
            📊 Exportar Excel
          </button>
        </div>
      </div>

      <div className="tabla-container">
        <table className="tabla-datos">
          <thead>
            <tr>
              <th onClick={() => ordenarPor('idDivision')} className="th-ordenable">
                ID División {columnaOrden === 'idDivision' && (ordenAsc ? '▲' : '▼')}
              </th>
              <th onClick={() => ordenarPor('nomDivision')} className="th-ordenable">
                Nombre {columnaOrden === 'nomDivision' && (ordenAsc ? '▲' : '▼')}
              </th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {datosFiltrados.length === 0 ? (
              <tr>
                <td colSpan="3" className="sin-datos">No hay datos para mostrar</td>
              </tr>
            ) : (
              datosFiltrados.map(item => (
                <tr key={item.idDivision}>
                  <td>{item.idDivision}</td>
                  <td>{item.nomDivision}</td>
                  <td>
                    <button
                      onClick={() => abrirModalEditar(item)}
                      className="btn-accion btn-editar"
                      title="Editar"
                    >
                      ✏️
                    </button>
                    <button
                      onClick={() => eliminar(item.idDivision)}
                      className="btn-accion btn-eliminar"
                      title="Eliminar"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="footer-tabla">
        <span>Total de registros: {datosFiltrados.length}</span>
      </div>

      {/* Modal */}
      {modalAbierto && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal-contenido" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{modoEdicion ? 'Editar División' : 'Nueva División'}</h3>
              <button onClick={cerrarModal} className="btn-cerrar">✖</button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>ID División *</label>
                <input
                  type="text"
                  name="idDivision"
                  value={formulario.idDivision}
                  onChange={handleChange}
                  maxLength="2"
                  disabled={modoEdicion}
                  className={`form-input ${errores.idDivision ? 'form-input-error' : ''}`}
                  placeholder="2 caracteres"
                />
                {errores.idDivision && (
                  <small className="form-error">{errores.idDivision}</small>
                )}
              </div>

              <div className="form-group">
                <label>Nombre División *</label>
                <input
                  type="text"
                  name="nomDivision"
                  value={formulario.nomDivision}
                  onChange={handleChange}
                  maxLength="140"
                  className={`form-input ${errores.nomDivision ? 'form-input-error' : ''}`}
                />
                {errores.nomDivision && (
                  <small className="form-error">{errores.nomDivision}</small>
                )}
              </div>

              <div className="modal-footer">
                <button type="button" onClick={cerrarModal} className="btn btn-cancelar">
                  Cancelar
                </button>
                <button type="submit" className="btn btn-guardar">
                  {modoEdicion ? 'Actualizar' : 'Guardar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default TDivisiones;
